<template>
    <div>

        <ul class="nav nav-tabs" id="tab-historico" role="tablist">
            <li class="nav-item" role="presentation" v-if="( ( lista_historico && lista_historico.length ) || ( legado && legado.length ) ) 
                && ( ( lista_marcar && lista_marcar.length > 0 ) || ( lista_retornos && lista_retornos.length ) )">
                <a class="nav-link active" id="historico-agenda-tab" data-toggle="tab" href="#historico-agenda" role="tab" aria-controls="historico-agenda" aria-selected="true">
                    Histórico
                    <span class="badge badge-secondary" v-if="lista_historico && legado">
                        {{ lista_historico.length + legado.length }}
                    </span>
                </a>
            </li>
            <li class="nav-item" role="presentation" v-if="lista_marcar && lista_marcar.length">
                <a class="nav-link" id="lista-marcar-tab" data-toggle="tab" href="#lista-marcar" role="tab" aria-controls="lista-marcar" aria-selected="false">
                    Para Marcar
                    <span class="badge badge-secondary" v-if="lista_marcar && lista_marcar.length">
                        {{ lista_marcar.length }}
                    </span>
                </a>
            </li>
            <li class="nav-item" role="presentation" v-if="lista_retornos && lista_retornos.length">
                <a class="nav-link" id="lista-retorno-tab" data-toggle="tab" href="#lista-retorno" role="tab" aria-controls="lista-marcar" aria-selected="false">
                    Retornos
                    <span class="mr-1" v-if="lista_retornos.find(retorno => retorno.dt_retorno <= $util.hoje() )" title="Retorno já vencido.">
                        <i class="fa-solid fa-triangle-exclamation text-danger"></i>
                    </span>
                    <span class="mr-1" v-else-if="lista_retornos.find(retorno => retorno.dt_retorno <= $util.ultimo_dia_mes($util.hoje()) )" title="Retorno perto de vencer.">
                        <i class="fa-solid fa-triangle-exclamation text-warning"></i>
                    </span>
                    <span class="badge badge-secondary" v-if="lista_retornos && lista_retornos.length">
                        {{ lista_retornos.length }}
                    </span>
                    
                </a>
            </li>
        </ul>

        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="historico-agenda" role="tabpanel" aria-labelledby="historico-agenda-tab">

                <az-input
                    v-if="lista_historico && lista_autorizacao_filtrada && legado 
                        && ( lista_autorizacao_filtrada.length || lista_historico.length || lista_legado_filtrada.length )"
                    sizing="sm"
                    class="my-1"
                    icon="fa fa-search" 
                    placeholder="Pesquisar..."
                    v-model="search">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">{{ lista_legado_filtrada.length + lista_historico_filtrada.length }}</span>
                        </div>
                    </template>
                </az-input>

                <template v-if="lista_autorizacao_filtrada.length">

                    <ul class="list-group mb-3">
                        <li class="list-group-item" v-for="(item, index) in lista_autorizacao_filtrada" :key="'AUT' + index"
                            :class="'alert-' + item.status_solicitacao.color">

                            <div class="d-flex justify-content-between align-items-center">

                                <div>
                                    <h5>
                                        <span class="badge" :class="'badge-' + item.status_solicitacao.color">
                                            {{ item.status_solicitacao.msg }}
                                        </span>
                                        Autorização <span class="small text-muted">{{ item.id_solicitacao_autorizacao }}</span>

                                        <span v-if="item.dt_valid_termino && item.status_solicitacao.color == 'success'">
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            Validade: {{ $util.getFormatDate(item.dt_valid_termino) }}
                                        </span>
                                        <span v-if="item.condicao_validade" class="badge" :class="'badge-' + item.condicao_validade.color">
                                            {{ item.condicao_validade.msg }}
                                        </span>
                                    </h5>
                                    <div class="d-flex">
                                        <span>
                                            {{ item.procedimento.search }}
                                        </span>
                                    </div>
                                    <div class="small" v-if="item.outros_proc_lista">
                                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                        {{ item.outros_proc_lista }}
                                    </div>
                                    <div>
                                        <small>{{ item.medico.search }}</small> |
                                        <template v-if="item.unidade_operacao && item.unidade_operacao.st_sigla">
                                            <small>{{ item.unidade_operacao.st_sigla }}</small> |
                                        </template>
                                        <small v-if="item.plano">{{ item.plano.search }}</small> |
                                        <small>
                                            AUTORIZAÇÃO |
                                            {{ getFormatDate (item.dt_solicitacao, 'DD/MM/YYYY') }}
                                        </small>
                                    </div>
                                    <div class="small text-muted" v-if="item.st_comentarios" style="white-space: pre;">{{ item.st_comentarios }}</div>
                                </div>
                                <div class="d-flex">
                                    <div v-if="!naoalterar">
                                        <div class="dropdown" v-if="$store.state.user.st_tipo != 'P'">
                                            <button class="btn btn-outline-success btn-sm mr-3 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="$store.state.loading">
                                                Marcar
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item" href="#" @click.prevent="revisao (item)">Mesmo Médico</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" href="#" @click.prevent="revisao (item, true)">Outro Médico</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </li>
                    </ul>

                    <pre v-if="false" class="alert alert-info">{{ autorizacao }}</pre>
                </template>

                <ul class="list-group">
                    <li class="list-group-item" v-for="(item, index) in lista_historico_filtrada" :key="'M' + index"
                        :class="'alert-' + ( ( item && item.item_status ) ? item.item_status.cor : 'secondary' )">

                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 v-if="item.autorizacao && item.autorizacao.status_solicitacao">
                                    <span class="badge" :class="'badge-' + item.autorizacao.status_solicitacao.color" data-toggle="tooltip" data-placement="top" title="Processo de Autorização">
                                        <i class="fas fa-stamp mr-2"></i>
                                        {{ item.autorizacao.status_solicitacao.msg }}
                                    </span>
                                </h5>
                                <div class="d-flex" v-if="!blockproc">
                                    <span>
                                        {{ item.procedimento.search }}
                                        <span
                                            class="badge badge-pill"
                                            :class="item.ch_tipo_consulta == 'R' ? 'badge-danger' : (
                                                item.ch_tipo_consulta == 'P' ? 'badge-info' : 'badge-warning'
                                            )"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            :title="item.ch_tipo_consulta == 'I' ? 'Inicial' : (
                                                        item.ch_tipo_consulta == 'R' ? 'Revisão' : (
                                                        item.ch_tipo_consulta == 'S' ? 'Subsequente' : (
                                                        item.ch_tipo_consulta == 'P' ? 'Pré-Natal' : ''
                                                        ) ) )"
                                            v-if="item && item.ch_tipo_consulta">
                                            {{ item.ch_tipo_consulta }}
                                        </span>

                                        <span v-if="nps && ( item.in_nps_score || item.in_nps_score === 0 )" class="badge ml-1" :class="'badge-' + ( item.in_nps_score < 7 ? 'danger' : ( item.in_nps_score < 9 ? 'warning' : 'success' ) )">
                                            <i class="fa-solid fa-star mr-1"></i> {{ item.in_nps_score }}
                                        </span>

                                        <a href="#" @click.prevent="exibir_info(
                                                ( item.nome_paciente ? item.nome_paciente + ': \n' : '' ) + 
                                                item.outros_proc_lista, 'Procedimentos adicionais')"
                                            v-if="!item.id_atendimento && item.outros_proc">
                                            <span class="badge badge-pill badge-primary ml-1" :title="'Procedimentos adicionais: ' + item.outros_proc_lista">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                                {{ item.outros_proc }}
                                            </span>
                                        </a>
                                    
                                        <a href="#" @click.prevent="exibir_info('Procedimentos', 'Procedimentos', item.id_atendimento)"
                                            v-else-if="item.id_atendimento && item.atendimento && item.atendimento.atendimento_procedimentos_count > 1">
                                            <span class="badge badge-pill badge-primary ml-1" title="Procedimentos">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                                {{ item.atendimento.atendimento_procedimentos_count - 1 }}
                                            </span>
                                        </a>
                                    </span>
                                    <span class="d-flex ml-2" v-if="!portal && item">
                                        <celula-horarios-marcacao :hor="{ marcacao: item }" :onlyPanel="true" />

                                        <a href="#" @click.prevent="ver_amostras(item)" class="card-link ml-2" v-if="item.id_atendimento && item.ch_estado_marcacao == 'A' && item.procedimento.id_especialidade == 2" title="Amostras">
                                            <i class="fa-solid fa-vials"></i>
                                        </a>
                                    </span>
                                </div>
                                <div>
                                    <small>{{ item.medico.search }}</small> |
                                    <template v-if="item.unidade_operacao && item.unidade_operacao.st_sigla">
                                        <small>{{ item.unidade_operacao.st_sigla }}</small> |
                                    </template>
                                    <small v-if="item.plano && item.plano.operadora">{{ item.plano.search }}</small> |
                                    <small>
                                        {{ getFormatDate (item.dt_inicio, 'DD/MM/YYYY') }} às
                                        {{ item.dt_inicio.substr(11,5) }}
                                    </small> |
                                    <small v-if="item.dt_inicio && ( item.dt_inicio.slice(0,10) != $util.hoje() )">{{ getHumanDuration (item.dt_inicio) }}</small>
                                    <span v-else class="badge badge-dark">{{ getHumanDuration (item.dt_inicio) }}</span>

                                    <span v-if="item.sinalizador_atendimento" class="ml-3" :title="item.sinalizador_atendimento.search">
                                        <i :class="item.sinalizador_atendimento.st_icon + ' text-' + item.sinalizador_atendimento.st_cor"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div v-if="!naoalterar">
                                    <button type="button" class="btn btn-outline-primary btn-sm mr-3" @click="remarcar (item)"
                                        v-if="( item.item_status.valor == 'agendado' || item.item_status.valor == 'bloqueado' ) && !naoremarcar">
                                        Remarcar
                                    </button>
                                    
                                    <button type="button" class="btn btn-outline-primary btn-sm mr-1" @click="confirmar (item)"
                                        v-if="( item.item_status.valor == 'agendado' ) && ( item.status_confirmacao && item.status_confirmacao.substr(0,7) == 'A Confi' ) && !naoremarcar && podeconfirmar">
                                        Confirmar
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm mr-3" @click="cancelar (item)"
                                        v-if="( item.item_status.valor == 'agendado' || item.item_status.valor == 'bloqueado' ) && !blockcancelar">
                                        Cancelar
                                    </button>
                                </div>
                                <div>
                                    <span v-if="tem_revisao(item) && !tela_aut">
                                        <button type="button" class="btn btn-outline-success btn-sm mr-3" @click="revisao (item)"
                                            :disabled="$store.state.loading">
                                            Marcar Revisão
                                        </button>
                                    </span>
                                    <small v-if="item.ch_estado_marcacao == 'C' && item.st_motivo_cancelamento && !portal" class="mr-3">
                                        {{ item.st_motivo_cancelamento }}
                                    </small>
                                    <span v-if="item && item.item_status">
                                        <i class="fa-2x" :class="item.item_status.icon"
                                            data-toggle="tooltip" data-placement="top" :title="item.item_status.valor"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.repeticao" class="text-right">
                            <div>
                                <i class="fas fa-sync-alt mr-1"></i>
                                <span class="badge badge-secondary ml-1" v-for="(dia, idiax) in item.dias" :key="idiax">
                                    {{ dia }}
                                </span>
                            </div>
                            <div>
                                <span class="dropdown" v-for="(rec, id_marcacao, irecx) in item.recorrencias" :key="irecx">
                                    <button class="btn btn-primary btn-sm p-1 ml-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      {{ $util.getFormatDate(rec) }}
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item disabled" href="#" @click.prevent>{{ $util.getFormatDate(rec) }} {{ rec.slice(11,16) }}</a>  
                                        <a class="dropdown-item" href="#" @click.prevent="remarcar(item, id_marcacao)">Remarcar</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item text-danger" href="#" @click.prevent="cancelar(item, rec, id_marcacao)">Cancelar</a>
                                    </div>
                                </span>

                                <!-- 
                                <span class="badge badge-primary ml-1" v-for="(rec, irecx) in item.recorrencias" :key="irecx">
                                    {{ $util.getFormatDate(rec) }}
                                </span>
                                -->
                            </div>
                        </div>
                        <div v-if="poderevisar && item.pedido" class="mt-3">
                            <div v-for="(pedido, ipx) in item.pedido" :key="ipx">
                                <div class="small" v-if="pedido.atendimento_procedimento.anamnese.requisicao.find(req => req.items.length)">Requisição</div>
                                <div class="card mb-0" v-for="(req, irx) in pedido.atendimento_procedimento.anamnese.requisicao" :key="irx">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex justify-content-between" v-for="(req_item, irix) in req.items" :key="irix">
                                            <div>{{ req_item.item.search }}</div>
                                            <button type="button" class="btn btn-sm btn-outline-success" @click="agendar(req_item)" v-if="!portal">
                                                {{ tela_aut ? 'Selecionar' : 'Agendar' }}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li class="list-group-item" v-for="(item, index) in lista_legado_filtrada" :key="'L' + index"
                        :class="'alert-success'">

                        <div class="d-flex justify-content-between">
                            <div>
                                <div>
                                    {{ item.st_descricao }}
                                </div>
                                <div>
                                    <small>{{ item.st_nome_medico }}</small> |
                                    <small>
                                        {{ getFormatDate (item.dt_data, 'DD/MM/YYYY') }}
                                    </small> |
                                    <small>{{ getHumanDuration (item.dt_data) }}</small>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div>
                                    <span>
                                        <i class="fa fa-check text-success fa-2x" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
                
            </div>

            <!-- Lista para Marcação -->
            <div class="tab-pane fade" id="lista-marcar" role="tabpanel" aria-labelledby="lista-marcar-tab">

                <ul class="list-group">
                    <li class="list-group-item" v-for="(item, index) in lista_marcar" :key="'M' + index"
                        :class="'alert-' + item.item_status.cor">

                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <div class="d-flex">
                                    <span>
                                        {{ item.procedimento.search }}
                                        <span
                                            class="badge badge-pill badge-warning"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            :title="item.ch_tipo_consulta == 'I' ? 'Inicial' : (
                                                        item.ch_tipo_consulta == 'R' ? 'Revisão' : (
                                                        item.ch_tipo_consulta == 'S' ? 'Subsequente' : '' ) )"
                                            v-if="item && item.ch_tipo_consulta">
                                            {{ item.ch_tipo_consulta }}
                                        </span>
                                    </span>
                                </div>
                                <div>
                                    <small>{{ item.medico.search }}</small> |
                                    <template v-if="item.unidade_operacao && item.unidade_operacao.st_sigla">
                                        <small>{{ item.unidade_operacao.st_sigla }}</small> |
                                    </template>
                                    <small v-if="item.plano && item.plano.operadora">{{ item.plano.search }}</small> |
                                    <small>
                                        {{ getFormatDate (item.dt_inicio, 'DD/MM/YYYY') }} às
                                        {{ item.dt_inicio.substr(11,5) }}
                                    </small> |
                                    <small>{{ getHumanDuration (item.dt_inicio) }}</small>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div>
                                    <span v-if="tem_revisao(item)">
                                        <button type="button" class="btn btn-outline-success btn-sm mr-3" @click="revisao (item)"
                                            :disabled="$store.state.loading">
                                            Marcar Revisão
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="poderevisar && item.pedido" class="mt-3">
                            <div v-for="(pedido, ipx) in item.pedido" :key="ipx">
                                <div class="small" v-if="pedido.atendimento_procedimento.anamnese.requisicao.find(req => req.items.length)">Requisição</div>
                                <div class="card mb-0" v-for="(req, irx) in pedido.atendimento_procedimento.anamnese.requisicao" :key="irx">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item d-flex justify-content-between" v-for="(req_item, irix) in req.items" :key="irix">
                                            <div>{{ req_item.item.search }}</div>
                                            <button type="button" class="btn btn-sm btn-outline-success" @click="agendar(req_item)">
                                                {{ tela_aut ? 'Selecionar' : 'Agendar' }}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>

            </div>

            <!-- Lista para Marcação -->
            <div class="tab-pane fade" id="lista-retorno" role="tabpanel" aria-labelledby="lista-retorno-tab">

                <ul class="list-group">
                    <li class="list-group-item" v-for="(item, index) in lista_retornos" :key="'R' + index">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <div>
                                    {{ item.procedimento.search }}
                                </div>
                                <div class="small">
                                    {{ item.medico.search }} 
                                    <span v-if="item.created_at">
                                        em {{ $util.getFormatDate(item.created_at.substr(0,10)) }}
                                    </span>
                                </div>
                                <div>
                                    Para: 
                                    {{ $util.getFormatDate(item.dt_retorno) }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    <span>{{ getHumanDuration (item.dt_retorno) }}</span>
                                </div>
                                <div v-if="item.st_observacoes" class="small text-muted">
                                    {{ item.st_observacoes }}
                                </div>
                            </div>
                            <div class="d-flex">
                                <div>
                                    <span>
                                        <button type="button" class="btn btn-outline-success btn-sm mr-3" @click="revisao (item)" :disabled="$store.state.loading">
                                            Marcar
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>

            </div>

        </div>

        <!-- Cancelar Marcação -->
        <cancelar-marcacao ref="canc_atd" @cancelado="$emit('refresh')" />

        <!-- Amostras -->
        <amostras ref="amostras" :viewonly="true" v-if="!portal && para_ver_amostras"/>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import CancelarMarcacao from './CancelarMarcacao.vue';
import CelulaHorariosMarcacao from '../../shared/table/CelulaHorariosMarcacao.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import Amostras from '../laboratorio/Amostras.vue';

export default {
    data () {
        return {
            search: "", 
            para_ver_amostras: false, 
        }
    },

    components: {
        AzInput, 
        CancelarMarcacao,
        CelulaHorariosMarcacao,
        Amostras, 
    },

    props: [
        'historico',
        'naoremarcar',
        'naoalterar',
        'legado',
        'poderevisar',
        'portal',
        'autorizacao',
        'tela_aut',
        'retornos',
        'podeconfirmar', 
        'nps',
        'blockproc', 
        'blockcancelar', 
    ],

    computed: {
        lista_marcar: function () {
            if ( !this.historico )
                return [];

            if ( this.$store.state.user.st_tipo == 'P' || this.$store.state.user.st_tipo == 'X' )
                return [];

            return this.historico.filter(item => ( !item.item_status || item.item_status.valor != 'cancelado')
                && this.tem_revisao(item) );
        },

        lista_retornos: function () { 
            if ( !this.retornos )
                return [];

            if ( this.$store.state.user.st_tipo == 'P' || this.$store.state.user.st_tipo == 'X' )
                return [];

            return this.retornos;
        },

        lista_historico: function () {
            if ( this.portal ) {
                if ( !this.historico )
                    return [];

                return this.historico.filter(item => !item.item_status || item.item_status.valor != 'cancelado')
            }

            return this.historico;
        },

        lista_historico_filtrada: function () {
            if ( !this.lista_historico || !this.lista_historico.length )
                return [];

            const reg = this.$util.getregex(this.search);
            return this.lista_historico.filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista_autorizacao_filtrada: function () { 
            if ( !this.autorizacao || !this.autorizacao.length || this.$store.state.user.st_tipo == 'P' || this.$store.state.user.st_tipo == 'X' )
                return [];

            const reg = this.$util.getregex(this.search);
            return this.autorizacao.filter(item => !this.search || reg.test(JSON.stringify(item)));
        },

        lista_legado_filtrada: function () { 
            if ( !this.legado || !this.legado.length )
                return [];

            const reg = this.$util.getregex(this.search);
            return this.legado.filter(item => !this.search || reg.test(JSON.stringify(item)));
        }
    },

    methods: {
        ver_amostras (marcacao) { 
            this.para_ver_amostras = true; 

            this.$nextTick(() => { 
                this.$refs.amostras.abrir(marcacao.id_atendimento);
            });
        },

        exibir_info (texto, titulo = 'Atenção', id_atendimento = null) { 
            if ( id_atendimento ) { 
                this.$util.loadItem(this, { 
                    service: 'atendimentos',
                    parms: { 
                        id: id_atendimento, 
                        lista_proc: true, 
                    }
                })
                .then(res => { 
                    console.log('ATP', res);
                    let lista = res.atendimento_procedimentos.map(item => item.procedimento.search).join(', ');
                    this.exibir_info(lista, 'Procedimentos');
                });

                texto = 'Carregando...';
            }

            this.$toast.add({
                severity: "info",
                summary: titulo,
                detail: texto,
                life: ( id_atendimento ? 3000 : 20000 )
            });
        },

        tem_revisao (item) {
            return this.poderevisar
                && ( item.ch_tipo_consulta == 'I' || item.ch_tipo_consulta == 'S' )
                && ( item.ch_estado_marcacao == 'A' )
                && ( item.id_atendimento )
                && ( item.dt_prazo_revisao > this.$util.hoje() );
        },

        revisao(item, outro = false) {
            if ( outro ) { 
                let marc = _.cloneDeep(item);
                marc.medico = null;
                this.$emit('revisao', marc);    
                return;
            }

            this.$emit('revisao', item);
        },

        confirmar(marcacao) {
            this.$emit('confirmar', marcacao);
        },

        agendar(item) {
            this.$emit('agendar', {
                ...item.item,
                id_requisicao: item.id_requisicao,
            });
        },

        getFormatDate (date, format) {
            return moment(date, 'YYYY-MM-DD').format(format);
        },

        getHumanDuration (date) {
            let end = moment().startOf('day');
            let base = date.substr (0,10);

            if ( base == this.$util.hoje() )
                return 'hoje';
            else
                return moment.duration(moment(base, 'YYYY-MM-DD').diff(end)).humanize(true);
        },

        remarcar (marcacao, id_marcacao_rec = null) {
            let marc = _.cloneDeep(marcacao);

            if ( id_marcacao_rec ) { 
                marc.id_marcacao = id_marcacao_rec;
            }

            console.log('marcacao', marcacao);
            console.log('rec', id_marcacao_rec);
            console.log('marc', marc);

            if ( this.portal ) { 
                this.$emit('remarcar', marc);
            } else { 
                this.$router.push({
                    params: {
                        id_paciente: marc.id_paciente,
                        remarcacao: marc.id_marcacao,
                        trocarmedico: false,
                    },
                });
            }
        },

        cancelar(marcacao, dt_inicio_rec = null, id_marcacao_rec = null) {
            let marc = _.cloneDeep(marcacao);

            if ( id_marcacao_rec ) { 
                marc.id_marcacao = id_marcacao_rec;
                marc.dt_inicio = dt_inicio_rec;
            }

            this.$refs.canc_atd.cancelar(marc);
        },

        verificar_aba() {
            if ( this.lista_marcar && this.lista_marcar.length ) {
                this.$nextTick(() => {
                    $('#tab-historico a[href="#lista-marcar"]').tab('show');
                });
            } else {
                this.$nextTick(() => {
                    $('#tab-historico a[href="#historico-agenda"]').tab('show');
                });
            }
        },

    }
}
</script>
